import { FC } from 'react';
import Card from './ContentCard';
import { ContentShowListProps } from 'MiniSiteComponents/ContentShow/ContentShow.interface';
import './ContentAndDocs.css';
import CarouselItem from '../../Carousel/Carousel.interface';

const LIMIT_CONTENT = true;

const ContentAndDocsList: FC<ContentShowListProps> = (props) => {

    const { items, componentId, iconView, isShowMore, itemsToShowOnLoad, linkTarget, showFilters, filters } = props;
    const isMobile = window.matchMedia("(max-width: 1024px)").matches;
    const limitContent = isMobile || LIMIT_CONTENT;

    function GetFilterItems(item: CarouselItem): { icon: string; title: string; info: string; }[] {
        var icons = [
            {
                icon: item.filter_1.icon,
                info: item.filter_1.selectedValue,
                title: item.filter_1.name
            },
            {
                icon: item.filter_2.icon,
                info: item.filter_2.selectedValue,
                title: item.filter_2.name
            },
            {
                icon: item.filter_3.icon,
                info: item.filter_3.selectedValue,
                title: item.filter_3.name
            },
            {
                icon: item.filter_4.icon,
                info: item.filter_4.selectedValue,
                title: item.filter_4.name
            },
            {
                icon: item.filter_5.icon,
                info: item.filter_5.selectedValue,
                title: item.filter_5.name
            },
        ]
        return icons;
    }

    return (
        <div className="mst-content-and-docs container px-lg-0">
            {
                items.map((item, idx) => {
                    const displayItem = idx < itemsToShowOnLoad || isShowMore;

                    return <div className={`${displayItem ? '' : 'd-none'}`}>
                        <Card key={idx}>

                        <Card.Header>
                            {
                                iconView ?
                                    <Card.Header.Icon icon={item.icon} /> :
                                    <Card.Header.Image image={item.image} mobileImage={item.mobileImage} />
                            }
                            <Card.HeaderTextsWrapper className={!item.richDescription ? 'align-self-center' : ''}>

                                <Card.Header.Title title={item.title} />
                                <Card.Header.SubTitle text={item.richDescription} />

                            </Card.HeaderTextsWrapper>

                        </Card.Header>

                        {showFilters && 
                                <Card.FilterIcons icons={GetFilterItems(item)} />
                        }

                        {
                            (item.content || item.link.url) &&
                            <Card.Description
                                hasChildren={!!item.link.url}
                                limitContent={limitContent}
                                contentId={`${componentId}-${idx}`}
                                content={item.content}>

                                <Card.LinkBtn link={item.link} linkTarget={linkTarget} />

                            </Card.Description>
                        }

                        </Card>
                    </div>
                })
            }
        </div>
    )
}


export default ContentAndDocsList